// UI copy dictionary (Norwegian default, English secondary).
export const T = {
  no: {
    langName: "Norsk",
    metaTitle: "Skj\u00f8nnhetssalong Oslo Sentrum | Beauty By Magdalena",
    metaDescription:
      "Beauty By Magdalena \u2013 skj\u00f8nnhetssalong i Oslo Sentrum. Fotpleie, voksing, farging av vipper og bryn, og brynsforming. Send WhatsApp for pris og timebestilling.",
    nav: {
      services: "Tjenester",
      pricing: "Priser",
      gallery: "Galleri",
      reviews: "Omtaler",
      location: "Beliggenhet",
      hours: "\u00c5pningstider",
      contact: "Kontakt",
    },
    cta: {
      quote: "WhatsApp \u2013 Prisforesp\u00f8rsel",
      book: "Bestill time p\u00e5 WhatsApp",
      service: "Sp\u00f8r om pris",
      viewServices: "Se tjenester",
    },
    hero: {
      overline: "Premium beauty i Oslo Sentrum",
      title: "Skj\u00f8nnhet med presisjon \u2013 midt i Oslo",
      subtitle:
        "Fotpleie, voksing og farging og forming av bryn og vipper. Send en melding p\u00e5 WhatsApp for pris og ledige tider.",
      badge1: "Sentralt i Oslo",
      badge2: "Rask respons p\u00e5 WhatsApp",
      badge3: "\u00c5pent hver dag 13\u201320",
    },
    services: {
      overline: "Tjenester",
      title: "Behandlinger tilpasset deg",
      subtitle:
        "Fire fokuserte behandlinger \u2013 utf\u00f8rt med omhu og \u00f8ye for detaljer.",
      priceLabel: "Pris p\u00e5 foresp\u00f8rsel",
      fromLabel: "Fra",
      durationLabel: "Varighet: etter avtale",
      clusterTitle: "Bryn og vipper",
      clusterSubtitle: "Ofte booket sammen for et komplett, definert blikk.",
    },
    pricing: {
      overline: "Priser",
      title: "\u00c5pne priser, ingen overraskelser",
      subtitle:
        "Alle priser er i norske kroner og gjelder behandlinger utf\u00f8rt hos oss i Storgata 53F.",
      pedicureTitle: "Pedikyr",
      lashbrowTitle: "Bryn og vipper",
      waxingTitle: "Voksing \u2013 enkeltomr\u00e5der",
      combosTitle: "Voksing \u2013 kombinasjoner",
      packagesTitle: "Sesongpakker",
      packagesSubtitle: "Faste bes\u00f8k til lavere pris \u2013 begrenset periode.",
      popularLabel: "Mest booket",
      regularLabel: "Ordin\u00e6r pris",
      saveLabel: "Spar",
      perUnitSuffix: "per behandling",
      termsLabel: "Vilk\u00e5r",
    },
    trust: {
      overline: "Hvorfor Beauty By Magdalena",
      title: "Kvalitet du kan kjenne igjen",
      items: [
        {
          title: "Hygiene f\u00f8rst",
          body: "Rene rutiner og trygge produkter \u2013 alltid.",
        },
        {
          title: "Premium finish",
          body: "Detaljfokus som synes i resultatet.",
        },
        {
          title: "Oslo Sentrum",
          body: "Enkelt \u00e5 komme til \u2013 Storgata 53F, 0182 Oslo.",
        },
      ],
    },
    location: {
      overline: "Beliggenhet",
      title: "Midt i Oslo Sentrum",
      areasTitle: "Omr\u00e5der vi betjener",
      transportTitle: "Kollektiv og parkering",
      transport: [
        "Trikk (linje 11, 12, 13, 17, 18) stopper ved Storgata.",
        "Kort vei fra Jernbanetorget og Oslo S.",
        "Gr\u00f8nland og Jernbanetorget T-banestasjoner i n\u00e6rheten.",
        "Offentlig parkering ved Oslo City og Q-Park i g\u00e5avstand.",
      ],
      mapCta: "\u00c5pne i Google Maps",
    },
    hours: {
      overline: "\u00c5pningstider",
      title: "N\u00e5r vi holder \u00e5pent",
      everyday: "Hver dag",
      note: "Timer etter avtale \u2013 send oss en melding p\u00e5 WhatsApp.",
    },
    ctaBand: {
      title: "Klar for din neste behandling?",
      subtitle:
        "Send oss en melding p\u00e5 WhatsApp for pris og ledig time. Vi svarer raskt.",
    },
    footer: {
      tagline: "Skj\u00f8nnhetssalong i Oslo Sentrum.",
      contactTitle: "Kontakt",
      hoursTitle: "\u00c5pningstider",
      legalTitle: "Juridisk",
      rights: "Alle rettigheter forbeholdt.",
      privacy: "Personvern",
      terms: "Vilk\u00e5r",
      cookies: "Informasjonskapsler",
      cookieSettings: "Cookie-innstillinger",
      shareTitle: "Del oss",
      shareEmail: "E-post",
      copyLabel: "Kopier lenke",
      copiedLabel: "Kopiert!",
    },
    cookie: {
      body:
        "Vi bruker informasjonskapsler for at nettstedet skal fungere, og analyse hvis du godtar.",
      acceptAll: "Godta alle",
      rejectAll: "Kun n\u00f8dvendige",
      manage: "Tilpass",
      save: "Lagre valg",
      prefTitle: "Innstillinger for informasjonskapsler",
      prefIntro:
        "Velg hvilke kategorier du tillater. N\u00f8dvendige informasjonskapsler er alltid aktive.",
      essential: "N\u00f8dvendige",
      essentialDesc: "Kreves for at nettstedet skal fungere. Kan ikke sl\u00e5s av.",
      analytics: "Analyse",
      analyticsDesc: "Hjelper oss \u00e5 forst\u00e5 bruk og forbedre nettstedet.",
      marketing: "Markedsf\u00f8ring",
      marketingDesc: "Brukes for relevant markedsf\u00f8ring. Ingen aktive per n\u00e5.",
      always: "Alltid aktiv",
    },
    gallery: {
      overline: "Galleri",
      title: "Resultater som taler for seg selv",
      subtitle:
        "F\u00f8r og etter \u2013 se forskjellen v\u00e5re behandlinger gj\u00f8r. Dra i glidebryteren.",
      beforeLabel: "F\u00f8r",
      afterLabel: "Etter",
      dragHint: "Dra for \u00e5 sammenligne",
      demoBadge: "Demobilder \u2013 byttes ut med salongens egne bilder",
    },
    reviews: {
      overline: "Omtaler",
      title: "Det kundene v\u00e5re sier",
      subtitle:
        "Ekte tilbakemeldinger betyr alt for oss. Ekte Google-omtaler kobles p\u00e5 snart.",
      demoBadge: "Eksempelomtaler \u2013 ekte omtaler kommer snart",
      empty: "Ingen omtaler enn\u00e5.",
    },
    instagram: {
      overline: "Instagram",
      title: "F\u00f8lg oss p\u00e5 Instagram",
      subtitle: "Siste arbeider, inspirasjon og tilbud.",
      follow: "F\u00f8lg oss",
      demoBadge: "Demofeed \u2013 kobles til live Instagram senere",
    },
    legal: { close: "Lukk" },
  },

  en: {
    langName: "English",
    metaTitle: "Beauty Salon Oslo Sentrum | Beauty By Magdalena",
    metaDescription:
      "Beauty By Magdalena \u2013 beauty salon in Oslo Sentrum. Pedicure, waxing, lash & brow tinting and brow shaping. Message us on WhatsApp for prices and booking.",
    nav: {
      services: "Services",
      pricing: "Prices",
      gallery: "Gallery",
      reviews: "Reviews",
      location: "Location",
      hours: "Opening hours",
      contact: "Contact",
    },
    cta: {
      quote: "WhatsApp \u2013 Get a quote",
      book: "Book on WhatsApp",
      service: "Ask for price",
      viewServices: "View services",
    },
    hero: {
      overline: "Premium beauty in Oslo Sentrum",
      title: "Beauty with precision \u2013 in the heart of Oslo",
      subtitle:
        "Pedicure, waxing and lash & brow tinting and shaping. Message us on WhatsApp for prices and availability.",
      badge1: "Central Oslo",
      badge2: "Fast replies on WhatsApp",
      badge3: "Open daily 13:00\u201320:00",
    },
    services: {
      overline: "Services",
      title: "Treatments tailored to you",
      subtitle:
        "Four focused treatments \u2013 performed with care and an eye for detail.",
      priceLabel: "Price on request",
      fromLabel: "From",
      durationLabel: "Duration: by appointment",
      clusterTitle: "Brows & lashes",
      clusterSubtitle: "Often booked together for a complete, defined look.",
    },
    pricing: {
      overline: "Prices",
      title: "Open prices, no surprises",
      subtitle:
        "All prices are in Norwegian kroner and apply to treatments at our studio in Storgata 53F.",
      pedicureTitle: "Pedicure",
      lashbrowTitle: "Brows & lashes",
      waxingTitle: "Waxing – single areas",
      combosTitle: "Waxing – combinations",
      packagesTitle: "Seasonal packages",
      packagesSubtitle: "Regular visits at a lower price – limited period.",
      popularLabel: "Most booked",
      regularLabel: "Regular price",
      saveLabel: "Save",
      perUnitSuffix: "per treatment",
      termsLabel: "Terms",
    },
    trust: {
      overline: "Why Beauty By Magdalena",
      title: "Quality you can recognise",
      items: [
        { title: "Hygiene first", body: "Clean routines and safe products \u2013 always." },
        { title: "Premium finish", body: "Detail focus you can see in the result." },
        {
          title: "Oslo Sentrum",
          body: "Easy to reach \u2013 Storgata 53F, 0182 Oslo.",
        },
      ],
    },
    location: {
      overline: "Location",
      title: "In the heart of Oslo Sentrum",
      areasTitle: "Areas we serve",
      transportTitle: "Transport & parking",
      transport: [
        "Tram (lines 11, 12, 13, 17, 18) stops at Storgata.",
        "A short walk from Jernbanetorget and Oslo Central Station.",
        "Gr\u00f8nland and Jernbanetorget metro stations nearby.",
        "Public parking at Oslo City and Q-Park within walking distance.",
      ],
      mapCta: "Open in Google Maps",
    },
    hours: {
      overline: "Opening hours",
      title: "When we are open",
      everyday: "Every day",
      note: "By appointment \u2013 send us a message on WhatsApp.",
    },
    ctaBand: {
      title: "Ready for your next treatment?",
      subtitle:
        "Message us on WhatsApp for prices and an available time. We reply quickly.",
    },
    footer: {
      tagline: "Beauty salon in Oslo Sentrum.",
      contactTitle: "Contact",
      hoursTitle: "Opening hours",
      legalTitle: "Legal",
      rights: "All rights reserved.",
      privacy: "Privacy",
      terms: "Terms",
      cookies: "Cookies",
      cookieSettings: "Cookie settings",
      shareTitle: "Share us",
      shareEmail: "Email",
      copyLabel: "Copy link",
      copiedLabel: "Copied!",
    },
    cookie: {
      body:
        "We use cookies to make the site work, and analytics if you accept.",
      acceptAll: "Accept all",
      rejectAll: "Essentials only",
      manage: "Manage",
      save: "Save choices",
      prefTitle: "Cookie settings",
      prefIntro:
        "Choose which categories you allow. Essential cookies are always active.",
      essential: "Essential",
      essentialDesc: "Required for the site to work. Cannot be turned off.",
      analytics: "Analytics",
      analyticsDesc: "Helps us understand usage and improve the site.",
      marketing: "Marketing",
      marketingDesc: "Used for relevant marketing. None active at the moment.",
      always: "Always active",
    },
    gallery: {
      overline: "Gallery",
      title: "Results that speak for themselves",
      subtitle:
        "Before and after \u2013 see the difference our treatments make. Drag the slider.",
      beforeLabel: "Before",
      afterLabel: "After",
      dragHint: "Drag to compare",
      demoBadge: "Demo images \u2013 to be replaced with the salon's own photos",
    },
    reviews: {
      overline: "Reviews",
      title: "What our clients say",
      subtitle:
        "Real feedback means everything to us. Real Google reviews will be connected soon.",
      demoBadge: "Sample reviews \u2013 real reviews coming soon",
      empty: "No reviews yet.",
    },
    instagram: {
      overline: "Instagram",
      title: "Follow us on Instagram",
      subtitle: "Latest work, inspiration and offers.",
      follow: "Follow us",
      demoBadge: "Demo feed \u2013 connects to live Instagram later",
    },
    legal: { close: "Close" },
  },
};
